var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M20.3337209,30.318352 L38.9243981,9.56568369 C39.5302636,8.88767729 40.3966749,8.5 41.2998271,8.5 C42.0875613,8.5 42.8438652,8.79197133 43.4340482,9.32596193 C44.7554464,10.5208062 44.8637423,12.5937171 43.6725207,13.9254287 L27.0345587,32.4996243 L43.6723275,51.0763262 C44.8635423,52.4064875 44.7552608,54.4786416 43.4340482,55.673318 L43.3726425,55.7282436 L43.2545944,55.8275085 C42.7054303,56.2585271 42.0498842,56.491919 41.3625569,56.5 L41.1323731,56.4943108 C40.2739059,56.4486343 39.4987934,56.0775837 38.9246203,55.4366812 L20.3342742,34.6786504 C19.2220008,33.4361715 19.2220008,31.5619631 20.3337209,30.318352 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.31161186f11d154cfde082341f46f0d6.svg";
export { ForwardRef as ReactComponent };